module.exports = __webpack_public_path__ + "static/media/idea_group_white.4ecf70bf.png";